// Safely renders arbitrary HTML in React
import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Box from "../atoms/Box"

const CustomHTML = ({ html }) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    // Find all <script> tags in the rendered HTML and re-insert them to execute
    container.querySelectorAll("script").forEach(oldScript => {
      const newScript = document.createElement("script")
      // Copy attributes (src, type, async and so on)
      Array.from(oldScript.attributes).forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      )
      // Copy inline script text
      newScript.text = oldScript.innerHTML
      // Replace old script with the new one
      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  }, [html]) // re-run whenever html changes

  return (
    /* The HTML snippet are render here */
    <Box
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: html }}
      suppressHydrationWarning
    />
  )
}

CustomHTML.propTypes = {
  html: PropTypes.string,
  ...Box.propTypes,
}

export default CustomHTML
